export const STONLY_ID = {
  predictiveScore: 'StonlySelectorPredictiveScore',
  urlReference: 'StonlySelectorURLReference',
  aiInstructions: 'StonlySelectorAIInstructions',
  blogWizard: 'StonlySelectorBlogWizard',
  favoriteTalkingPoint: 'StonlySelectorFavoriteTalkingPoint',
  brief: 'StonlySelectorBrief',
  targetAudience: 'StonlySelectorTargetAudience',
  talkingPoints: 'StonlySelectorTalkingPoints',
  toneOfVoice: 'StonlySelectorToneOfVoice',
  formulas: 'StonlySelectorFormulas',
  prompt: 'StonlySelectorPrompt',
  suggestions: 'StonlySelectorSuggestions',
  improve: 'StonlySelectorImprove',
};
